import { render, staticRenderFns } from "./jslist.vue?vue&type=template&id=1af97054&"
import script from "./jslist.vue?vue&type=script&lang=js&"
export * from "./jslist.vue?vue&type=script&lang=js&"
import style0 from "./jslist.vue?vue&type=style&index=0&id=1af97054&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports